export const R = {
	"ChildTermsTitle": "Jeg bekrefter herved at:",
	"ChildTermsBullet1": "jeg informerer andre personer med foreldreansvar for barnet om opprettelsen av barnets profil.",
	"ChildTermsBullet2": "jeg er kjent med at &lt;a href=\"https://app.hejdoktor.dk/privatlivspolitikk\" target=\"_blank\" class=\"underline\"&gt;Hejdoktors personvernerklæring&lt;/a&gt; også gjelder for barnet mitt",
	"AdolescentTerms": "Jeg bekrefter herved at jeg informerer andre med foreldreansvar for ungdommen om opprettelsen av ungdommens profil."
}